// src/components/LoginMobile.jsx

import { useContext, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import googleIcon from "../images/google-icon.png";
import USFlag from "../images/flags/uk-flag-icon.png";
import FranceFlag from "../images/flags/french-flag-icon.png";
import RehappLogo from "../images/logo_ticket_hub.png";

import { useAuth } from "../context/AuthContext";
import { LanguageContext } from "../context/LanguageContext";
import { showCustomToast } from "../misc/CustomToast";
import { db } from "../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { useTheme } from "@mui/material/styles";

export default function LoginMobile() {
  const { translate, language, setLanguage } = useContext(LanguageContext);
  const { signInWithGoogle, currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };
  const theme = useTheme();

  async function handleSignInWithGoogle() {
    try {
      const result = await signInWithGoogle();
      const email = result.user.email;
      const inviteQ = query(
        collection(db, "companies"),
        where("invitedEmails", "array-contains", email)
      );
      const inviteSnap = await getDocs(inviteQ);

      showCustomToast(translate("SuccessfullyLoggedInWithGoogle"), "success");
      navigate(inviteSnap.empty ? "/app/profile" : "/app", { replace: true });
    } catch (error) {
      showCustomToast(
        error.code === "permission-denied"
          ? translate("MustLogInWithGmailOrGsuite")
          : translate("Failed to log in with your Google account"),
        "error"
      );
    }
  }

  useEffect(() => {
    if (!currentUser) return;
    (async () => {
      const snap = await getDoc(doc(db, "profilsUsers", currentUser.uid));
      // if (snap.data()?.companyId) navigate("/app");
      if (snap.data()?.companyId) {
        navigate("/app", { replace: true });
      } else {
        navigate("/app/profile", { replace: true });
      }
    })();
  }, [currentUser, navigate]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          // paddingTop: "100px",
          height: "15vh",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <img src={RehappLogo} alt="Logo" height={80} />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "45vh",
          textAlign: "center",
          justifyContent: "space-around",
          alignContent: "space-between",
          paddingTop: "40px",
        }}
      >
        <Typography
          sx={{ fontSize: 18, fontWeight: 600, color: "text.primary" }}
        >
          {translate("WelcomeToTicketHub")}
        </Typography>

        <div
          style={{
            display: "flex",
            paddingTop: "50px",
            paddingBottom: "30px",
            paddingLeft: "40px",
            paddingRight: "40px",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <Button
            onClick={handleSignInWithGoogle}
            variant="outlined"
            sx={{
              fontSize: 16,
              fontWeight: 600,
              borderRadius: "30px",
              borderColor: "divider",
              color: "text.primary",
              px: 2.5,
              py: 1.25,
              display: "flex",
              alignItems: "center",
              textTransform: "uppercase",
              gap: 1.25,
              "&:hover": { borderColor: "divider" },
            }}
          >
            <img src={googleIcon} alt="Google" width={24} height={24} />
            {translate("LogInWithGoogle")}
          </Button>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "40vh",
          textAlign: "center",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          paddingTop: "40px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ width: "50%" }}>
            <FormControl fullWidth sx={{ mt: 3 }}>
              <InputLabel
                id="lang-select-mobile"
                sx={{
                  color: "text.secondary",
                  "&.Mui-focused": { color: "primary.main" },
                }}
              >
                {translate("Language")}
              </InputLabel>
              <Select
                sx={{
                  bgcolor: "background.paper",
                  color: "text.primary",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "divider",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "divider",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "primary.main",
                  },
                  "& .MuiSvgIcon-root": { color: "text.primary" },
                }}
                labelId="lang-select-mobile"
                value={language}
                label={translate("Language")}
                onChange={handleLanguageChange}
                renderValue={(val) => (
                  <Box display="flex" alignItems="center">
                    {val === "en" && (
                      <img
                        src={USFlag}
                        alt=""
                        width={20}
                        style={{ marginRight: 8 }}
                      />
                    )}
                    {val === "fr" && (
                      <img
                        src={FranceFlag}
                        alt=""
                        width={20}
                        style={{ marginRight: 8 }}
                      />
                    )}
                    {val === "en" ? "English" : "Français"}
                  </Box>
                )}
              >
                <MenuItem value="en">
                  <Box display="flex" alignItems="center" gap={1}>
                    <img src={USFlag} alt="" width={20} /> English
                  </Box>
                </MenuItem>
                <MenuItem value="fr">
                  <Box display="flex" alignItems="center" gap={1}>
                    <img src={FranceFlag} alt="" width={20} /> Français
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <div
          onClick={() => navigate("/")}
          style={{
            fontSize: "16px",
            paddingTop: "10px",
            paddingBottom: "20px",
            color: "inherit",
            cursor: "pointer",
          }}
        >
          {translate("WhoAreWe")}
        </div>
      </div>

      {/* <ToastContainer position="top-center" autoClose={1000} theme="dark" /> */}
      <ToastContainer
        position="top-center"
        autoClose={1000}
        theme={theme.palette.mode === "dark" ? "dark" : "light"}
      />
    </div>
  );
}
